<template>
    <div>
        <h1>{{$t('shared.technicalDocumentation')}}</h1>
        <el-collapse>
            <el-collapse-item name="1" v-if="$isFullAdmin">
                <template slot="title">
                    <p style="background-color: #ececec">
                        {{$t('technicaldocumentation.createFolder')}}
                        <i class="header-icon el-icon-info"></i>
                    </p>
                </template>
                <el-form :inline="true" ref="form" :model="form" :rules="rules" size="small" v-if="$isFullAdmin" style="margin-top: 15px;">
                    <el-form-item :label="$t('technicaldocumentation.parentFolder')">
                        <el-select v-model="form.parent" clearable>
                            <el-option v-for="item in folderList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('technicaldocumentation.newFolderName')" prop="name">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                    <el-button size="small" @click="addFolder">{{$t('common.create')}}</el-button>
                </el-form>
            </el-collapse-item>
            <el-collapse-item name="2" v-if="$isFullAdmin">
                <template slot="title">
                    <p style="background-color: #ececec">
                        {{$t('technicaldocumentation.uploadDocument')}}
                        <i class="header-icon el-icon-info"></i>
                    </p>
                </template>
                <el-form ref="uploadForm" :model="uploadForm" :rules="uploadRules" label-position="top" size="small" style="margin-top: 15px;">
                    <el-form-item :label="$t('technicaldocumentation.folder')">
                        <el-select v-model="uploadForm.folderId" clearable>
                            <el-option v-for="item in folderList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('technicaldocumentation.documents')">
                        <el-upload ref="uploader" drag multiple :auto-upload="false" :limit="10" action="" :on-change="documentPlaced"
                                   :on-remove="deleteAttachment">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">
                                {{$t('serviceTickets.dropFile')}}
                                <em>{{$t('serviceTickets.clicktoUpload')}}</em>
                            </div>
                        </el-upload>
                        <div v-model="uploadFilesLength">{{$t('technicaldocumentation.uploadedFilesLength')}} {{uploadFilesLength}} kB</div>
                    </el-form-item>
                    <el-button @click="uploadDocuments" :disable="uploading">{{$t('technicaldocumentation.upload')}}</el-button>
                    <progress max="100" :value.prop="uploadPercentage" v-show="uploading"></progress>
                </el-form>
            </el-collapse-item>
        </el-collapse>
        <!-- <el-row>
          <el-col :span="8">
            <el-input v-model="filter" style="margin-top: 20px; width: 60%;" prefix-icon="el-icon-search" type="search"></el-input>
            <el-button @click="loadDocumentation">Search</el-button>
          </el-col>
        </el-row> -->
        <node-tree @folderDeleted="folderDeleted" @documentDeleted="loadDocumentation" :nodes="folders"></node-tree>
        <div v-model="totalFilesLength">{{$t('technicaldocumentation.totalFilesLength')}} {{totalFilesLength}} MB</div>
    </div>
</template>

<script>
    import NodeTree from "./NodeTree";
    import api from "../api";
    import axios from "axios";
    export default {
        name: "documentation-list",
        components: {
            NodeTree
        },
        data(vm) {
            return {
                totalFiles: 0,
                uploadFilesLength: 0,
                totalFilesLength: 0,
                loading: false,
                uploading: false,
                folderList: [],
                folders: [],
                uploadPercentage: 0,
                form: {
                    name: "",
                    parent: undefined
                },
                rules: {
                    name: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterName'),
                            trigger: "blur"
                        }
                    ]
                },
                uploadForm: {
                    folderId: undefined,
                    documents: []
                },
                uploadRules: {
                    folder: [
                        {
                            required: true,
                            message: vm.$t('common.pleaseSelectFolder'),
                            trigger: "change"
                        }
                    ],
                    documents: [
                        {
                            type: "array",
                            message: vm.$t('common.pleaseSelectDocumentsToUpload'),
                            required: true,
                            trigger: "change"
                        }
                    ]
                }
            };
        },
        created() {
            this.loadDocumentation();
            this.loadFolders();
        },
        methods: {
            getTotal(fileList) {
                for (let i = 0; i < fileList.length; i++) {
                    this.uploadFilesLength += fileList[i].size;
                }
                this.uploadFilesLength = Math.floor(this.uploadFilesLength / 1024);
            },
            deleteAttachment(file, fileList) {
                this.getTotal(fileList);
            },
            documentPlaced(file, fileList) {
                this.getTotal(fileList);
                this.uploadForm.documents = fileList.map(f => f.raw);
            },
            countTotalSize(value, folders){
                for (let i = 0; i < folders.length; i++) {
                    let folder = folders[i];
                    value += folder.folderSize;
                    if (folder.children.length) {
                        for (let j = 0; j < folder.children.length; j++) {
                            value += this.countTotalSize(value, [folder.children[j]]);
                        }
                    }
                }
                return value;
            },
            loadDocumentation() {
                this.loading = true;
                api.getDocumentation().then(response => {
                    this.folders = response.data;
                    this.loading = false;
                    let size =  this.countTotalSize(0, this.folders);
                    this.totalFilesLength = Math.floor(size/ 1024 / 1024);
                });
            },
            loadFolders() {
                api.getFolders().then(response => {
                    this.folderList = response.data;
                });
            },
            addFolder() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        api.createFolder(this.form).then(response => {
                            this.$notify({
                                title: this.$t('common.success'),
                                message: this.$t('common.folderSuccesfullyCreated'),
                                type: "success"
                            });
                            this.$refs["form"].resetFields();
                            this.loadFolders();
                            this.loadDocumentation();
                        });
                    }
                });
            },
            uploadDocuments() {
                this.$refs["uploadForm"].validate(valid => {
                    if (valid) {
                        this.uploading = true;
                        var form = this.uploadForm;
                        var fd = new FormData();
                        for (let prop in form) {
                            if (form.hasOwnProperty(prop)) {
                                if (prop === "documents") {
                                    for (let i = 0; i < form.documents.length; i++) {
                                        if (form.documents[i] instanceof File) {
                                            fd.append(`documents`, form.documents[i]);
                                        }
                                    }
                                } else {
                                    fd.append(prop, form[prop]);
                                }
                            }
                        }
                        axios
                            .post("/api/technicaldocumentation", fd, {
                                headers: {
                                    "Content-Type": "multipart/form-data"
                                },
                                onUploadProgress: function (progressEvent) {
                                    this.uploadPercentage = parseInt(
                                        Math.round(progressEvent.loaded * 100 / progressEvent.total)
                                    );
                                }.bind(this)
                            })
                            .then(response => {
                                this.$notify({
                                    title: this.$t('common.success'),
                                    message: this.$t('common.documentsSuccesfullySubmitted'),
                                    type: "success"
                                });
                                this.$refs["uploader"].clearFiles();
                                this.$refs["uploadForm"].resetFields();
                                this.uploadPercentage = 0;
                                this.uploadForm.folderId = null;
                                this.loadDocumentation();
                                this.uploading = false;
                            })
                            .catch(response => {
                                this.uploading = false;
                            });
                    }
                });
            },
            folderDeleted() {
                this.$notify({
                    title: this.$t('common.success'),
                    message: this.$t('common.folderSuccesfullyDeleted'),
                    type: "success"
                });
                loadFolders();
                loadDocumentation();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ClientApp/app/technicaldocumentation/components/DocumentationList.vue